export default "__VITE_ASSET__8T2L4iXk__"